export class Logger {
  static log(message?: unknown, ...optionalParams: unknown[]): void {
    this._log('info', message, ...optionalParams)
  }

  static debug(message?: unknown, ...optionalParams: unknown[]): void {
    this._log('debug', message, ...optionalParams)
  }

  static info(message?: unknown, ...optionalParams: unknown[]): void {
    this._log('info', message, ...optionalParams)
  }

  static error(message?: unknown, ...optionalParams: unknown[]): void {
    this._log('error', message, ...optionalParams)
  }

  static warn(message?: unknown, ...optionalParams: unknown[]): void {
    this._log('warn', message, ...optionalParams)
  }

  private static _log(
    severity: keyof Pick<Console, 'warn' | 'error' | 'info' | 'debug'>,
    message?: unknown,
    ...optionalParams: unknown[]
  ) {
    const dateAndSeverity = `${new Date().toISOString()} ${severity.toUpperCase()}`
    //if message is an error, log the entire message object so we don't lose the stack trace due to string conversion
    if (message instanceof Error) {
      console[severity](dateAndSeverity, message, ...optionalParams)
    } else {
      console[severity](message ? `${dateAndSeverity} ${message}` : severity, ...optionalParams)
    }
  }
}
